"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7909],{

/***/ 285946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ BackArrow; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);



function BackArrow(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        height: props.height || 24,
        width: props.width || 24,
        viewBox: "0 0 447.243 447.243"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "#000000",
            d: "M420.361 192.229a31.967 31.967 0 00-5.535-.41H99.305l6.88-3.2a63.998 63.998 0 0018.08-12.8l88.48-88.48c11.653-11.124 13.611-29.019 4.64-42.4-10.441-14.259-30.464-17.355-44.724-6.914a32.018 32.018 0 00-3.276 2.754l-160 160c-12.504 12.49-12.515 32.751-.025 45.255l.025.025 160 160c12.514 12.479 32.775 12.451 45.255-.063a32.084 32.084 0 002.745-3.137c8.971-13.381 7.013-31.276-4.64-42.4l-88.32-88.64a64.002 64.002 0 00-16-11.68l-9.6-4.32h314.24c16.347.607 30.689-10.812 33.76-26.88 2.829-17.445-9.019-33.88-26.464-36.71z"
        })
    }));
}


/***/ }),

/***/ 67865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _utils_deviceInfo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(990864);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(667294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(225617);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(119372);
/* harmony import */ var src_utils_canDisablePlaceOrder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(596930);
/**
 * Card Payment Input Component
 */ 






var CardPaymentBox = function(props) {
    var getCtaBtnText = function getCtaBtnText() {
        return props.isVerifyCard ? "VERIFY NOW" : "Pay";
    };
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return {
            store: state.storeReducer.store,
            orderDetails: state.orderReducer.orderDetails,
            loader: state.commonReducer.loader,
            storeData: state.storeReducer.store,
            userData: state.userReducer.data
        };
    }), store = ref.store, orderDetails = ref.orderDetails, loader = ref.loader, storeData = ref.storeData, userData = ref.userData;
    /**
   * UseEffect for prefilled card data
   */ (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        (store === null || store === void 0 ? void 0 : store.store_id) && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash) && dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_6__/* .fetchPaymentMethods */ .F7)({
            store_id: store === null || store === void 0 ? void 0 : store.store_id,
            hash: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash
        }));
    }, []);
    var validateAll = function() {
        return true;
    };
    var checkForValidCardLogic = function() {
        return true;
    };
    var onPayBtnClick = function() {
        if ((0,src_utils_canDisablePlaceOrder__WEBPACK_IMPORTED_MODULE_5__/* .canDisablePlaceOrder */ .w)()) {
            return;
        }
        if (validateAll() && checkForValidCardLogic()) {
            var ref, ref1, ref2, ref3;
            var data = {
                orderID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash,
                phone: userData === null || userData === void 0 ? void 0 : userData.phone,
                paymentMethod: "card",
                merchantID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.merchant_id,
                deviceType: (0,_utils_deviceInfo__WEBPACK_IMPORTED_MODULE_1__/* .getDeviceInfo */ .d)().OSName,
                browserType: (0,_utils_deviceInfo__WEBPACK_IMPORTED_MODULE_1__/* .getDeviceInfo */ .d)().BrowserName,
                userAgent: (0,_utils_deviceInfo__WEBPACK_IMPORTED_MODULE_1__/* .getDeviceInfo */ .d)().userAgent,
                source: "longtail",
                merchantName: "Digital Showroom - ".concat(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.name)
            };
            dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_6__/* .initPayment */ .yK)(data, router));
            /**
       * This was added as to fix bank redirection after confirming OTP on our temporary domains, as the redirection
       * only happens on domain i.e. showroom.dotpe.in & not on our path -> showroom.dotpe.in/${domain},
       * so redirection details are saved here.
       */ if ((storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain) && (storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.store_info) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.domain) === null || ref3 === void 0 ? void 0 : ref3.startsWith("d-temporary"))) {
                var ref4, ref5;
                sessionStorage.setItem("cardPaymentDetails", JSON.stringify({
                    paymentMethod: "card",
                    redirectionUrl: storeData === null || storeData === void 0 ? void 0 : (ref4 = storeData.store_info) === null || ref4 === void 0 ? void 0 : ref4.store_url,
                    storeDomain: storeData === null || storeData === void 0 ? void 0 : (ref5 = storeData.store_info) === null || ref5 === void 0 ? void 0 : ref5.domain
                }));
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "card-payment-box",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "card-wrapper",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                onClick: onPayBtnClick,
                className: "cta-btn ".concat(checkForValidCardLogic() ? "o-100 pointer" : "o-50"),
                disabled: loader || !checkForValidCardLogic(),
                children: !loader ? getCtaBtnText() : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/assets/images/ellipLoader1.gif",
                    className: "img h1"
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CardPaymentBox);


/***/ }),

/***/ 143388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(999534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);



var CustomRadio = function(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        className: "custom-radio ".concat(className ? className : ""),
        type: "radio"
    }, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomRadio);


/***/ }),

/***/ 757909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__": function() { return /* binding */ _getCODCharges; },
  "ZP": function() { return /* binding */ components_DesktopPaymentModal; }
});

// UNUSED EXPORTS: getItemTotal

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(629815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(811163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./node_modules/react-tooltip/dist/index.es.js + 3 modules
var index_es = __webpack_require__(924762);
// EXTERNAL MODULE: ./src/components/Common/Modal/index.jsx
var Modal = __webpack_require__(672651);
// EXTERNAL MODULE: ./src/utils/checkIfObjectExists.ts
var checkIfObjectExists = __webpack_require__(631891);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/utils/deviceInfo.js
var deviceInfo = __webpack_require__(990864);
// EXTERNAL MODULE: ./node_modules/react-qr-code/lib/index.js
var lib = __webpack_require__(101653);
// EXTERNAL MODULE: ./src/redux/actions/payment.js
var payment = __webpack_require__(119372);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
;// CONCATENATED MODULE: ./src/components/QRPaymentUPI/index.js
/**
 * QR payment for UPI
 */ 











var initialState = {
    otp: "",
    minutes: 3,
    seconds: 0,
    isTimeUp: false,
    qrText: "",
    showGenerateQr: true
};
var QRPaymentUPI = function(props) {
    var ref;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var timerID = null;
    var ref1 = (0,react.useState)(initialState), state = ref1[0], setState = ref1[1];
    var ref2 = (0,react.useState)(false), isTimerStarted = ref2[0], setIsTimerStarted = ref2[1];
    var ref3 = (0,es/* useSelector */.v9)(function(state) {
        return {
            orderDetails: state.orderReducer.orderDetails,
            storeInfo: state.storeReducer.store,
            loader: state.commonReducer.loader,
            userData: state.userReducer.data
        };
    }), orderDetails = ref3.orderDetails, storeInfo = ref3.storeInfo, loader = ref3.loader, userData = ref3.userData;
    var checkIfMDRActive = (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.mdr_flag) === 1;
    (0,react.useEffect)(function() {
        setState(initialState);
        return function() {
            setIsTimerStarted(false);
        };
    }, [
        props.partial_payment
    ]);
    // useEffect for timer
    (0,react.useEffect)(function() {
        if (isTimerStarted) {
            timerID = setInterval(function() {
                _timer(state);
            }, 1000);
        }
        return function() {
            clearTimer();
        };
    }, [
        state.minutes,
        state.seconds,
        isTimerStarted
    ]);
    var clearTimer = function() {
        timerID && clearInterval(timerID);
    };
    /**
   * Function update the state for timer
   * @param {Object} state
   */ var _timer = function(state) {
        if (state.seconds > 0) {
            setState(function(preState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, preState), {
                    seconds: preState.seconds - 1
                });
            });
        }
        if (state.seconds === 0) {
            if (state.minutes === 0) {
                clearTimer();
                setState(function(preState) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, preState), {
                        isTimeUp: true
                    });
                });
            } else {
                setState(function(preState) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, preState), {
                        minutes: preState.minutes - 1,
                        seconds: 59
                    });
                });
            }
        }
    };
    var initiatePayment = function(payload) {
        setIsTimerStarted(true);
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showGenerateQr: false
            });
        });
        // Intiate payment
        dispatch((0,payment/* initPaymentForQR */.qI)(payload, function(_intPay) {
            // If payment initiated successfully
            if (_intPay.status) {
                setState(function(state) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        minutes: 3,
                        seconds: 0,
                        isTimeUp: false,
                        showGenerateQr: false,
                        qrText: _intPay.intentLink
                    });
                });
                // Initiate the payment varification process
                if (_intPay.transactionId) {
                    dispatch((0,payment/* pollPayment */.ru)(_intPay.transactionId, router));
                }
            } else {
                setState(initialState);
                clearTimer();
                (0,Toast/* toastNotifyError */.Lu)("error: ".concat((_intPay === null || _intPay === void 0 ? void 0 : _intPay.message) || "Unable to initiate payment!"));
            }
        }));
        localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("orderID", orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash);
    };
    /**
   * Function to initiate a payment and
   * set the state with the new QR data
   */ var createNewQR = function() {
        var ref;
        var payload = {
            orderID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash,
            paymentMethod: constants/* PAYMENT_TYPE_CONSTANTS.DUPI */.Mf.DUPI,
            merchantID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.merchant_id,
            deviceType: (0,deviceInfo/* getDeviceInfo */.d)().OSName,
            browserType: (0,deviceInfo/* getDeviceInfo */.d)().BrowserName,
            userAgent: (0,deviceInfo/* getDeviceInfo */.d)().userAgent,
            phone: userData === null || userData === void 0 ? void 0 : userData.phone,
            source: "longtail",
            merchantName: "Digital Showroom - ".concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.name)
        };
        dispatch((0,payment/* savePaymentInfo */.YI)(payload));
        if (checkIfMDRActive && (0,checkIfObjectExists/* checkIfObjectExists */.L)(props.txnData)) {
            var mdrPld = {
                order_hash: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash,
                store_id: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.store_id,
                payment_option: props.txnData
            };
            dispatch((0,payment/* prePaymentCheckMDRTransactions */.HV)(mdrPld, function() {
                setTimeout(function() {
                    return initiatePayment(payload);
                }, 100);
            }));
        } else {
            initiatePayment(payload);
        }
    };
    var QrPlaceholder = function(param) {
        var children = param.children, classNameExtension = param.classNameExtension;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                    size: 150,
                    value: ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-black-80 absolute w-100 top-0 left-0 right-0 bottom-0  flex justify-center items-center ".concat(classNameExtension),
                    children: children
                })
            ]
        });
    };
    var _renderQR = function() {
        if (state.isTimeUp) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(QrPlaceholder, {
                classNameExtension: "bg-black-90",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "flex justify-center items-center pb2 fw6 f5 white ",
                    onClick: createNewQR,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "https://cdn.dotpe.in/longtail/themes/8073865/xoJCAYfj.webp",
                            className: "mr2 img h2"
                        }),
                        "Refresh"
                    ]
                })
            });
        }
        if (state.showGenerateQr) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(QrPlaceholder, {
                classNameExtension: "bg-black-70",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    style: {
                        cursor: "pointer"
                    },
                    className: "pa1 bg-white br2 bw0",
                    onClick: createNewQR,
                    children: "Generate Code"
                })
            });
        }
        return state.qrText && !loader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
            size: 150,
            value: state.qrText
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(QrPlaceholder, {
            classNameExtension: "bg-black-70",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "/assets/images/ellipLoader1.gif",
                className: "h2 img"
            })
        });
    };
    var _renderQrTimerMessage = function() {
        return state.isTimeUp ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "f7 fw3",
                children: "This QR code has expired"
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            className: "f7 fw3",
            children: [
                "This QR code will expire in 0",
                state.minutes,
                ":",
                state.seconds < 10 ? "0".concat(state.seconds) : state.seconds,
                " Minutes"
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "ph4 pt4 pb3 flex flex-column flex-auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "flex flex-column justify-center items-center",
                children: [
                    _renderQR(),
                    isTimerStarted ? _renderQrTimerMessage() : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb4"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "ba b--black-10 pv3 ph4 br3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                        className: "tc fw5 f5 pb2 lh-copy",
                        children: "Scan this QR code with any of your UPI App and pay."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                        className: "flex justify-center items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "https://cdn.dotpe.in/longtail/themes/8073865/TVi0GjBB.webp",
                                className: "img h2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "https://cdn.dotpe.in/longtail/themes/8073865/N2BcdtfG.webp",
                                className: "img h2 mh3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "https://cdn.dotpe.in/longtail/themes/8073865/WZktEt3t.webp",
                                className: "img h2"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_QRPaymentUPI = (QRPaymentUPI);

// EXTERNAL MODULE: ./src/components/CardPaymentBox/index.js
var CardPaymentBox = __webpack_require__(67865);
// EXTERNAL MODULE: ./src/components/EmiCardPayment/index.js
var EmiCardPayment = __webpack_require__(829875);
// EXTERNAL MODULE: ./src/components/CustomRadio/index.js
var CustomRadio = __webpack_require__(143388);
// EXTERNAL MODULE: ./src/components/LazyPayAuth/lazyPayAuth.js
var lazyPayAuth = __webpack_require__(514456);
// EXTERNAL MODULE: ./src/redux/store/index.js + 45 modules
var store = __webpack_require__(17247);
;// CONCATENATED MODULE: ./src/utils/checkForInvalidAmount.js


function checkForInvalidAmount() {
    var ref, ref1;
    var storeInfo = store/* default.getState */.Z.getState().storeReducer.store;
    var orderDetails = store/* default.getState */.Z.getState().orderReducer.orderDetails;
    if (((storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.payment_method) === constants/* PREPAID_POSTPAID_METHODS.BOTH */.R9.BOTH || (storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.services) === null || ref1 === void 0 ? void 0 : ref1.payment_method) === constants/* PREPAID_POSTPAID_METHODS.POSTPAID */.R9.POSTPAID) && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.buyer_pay_value) < constants/* MINIMUM_ORDER_AMOUNT */.BI) {
        return true;
    }
    return false;
}

// EXTERNAL MODULE: ./src/redux/actions/auth.js
var auth = __webpack_require__(368060);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(731024);
// EXTERNAL MODULE: ./src/redux/actions/order.js
var order = __webpack_require__(804160);
// EXTERNAL MODULE: ./src/redux/actions/logs.js
var logs = __webpack_require__(467936);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/util.js
var util = __webpack_require__(452388);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
// EXTERNAL MODULE: ./src/utils/getPrepaidInvalidAmountMessage.js
var getPrepaidInvalidAmountMessage = __webpack_require__(37202);
// EXTERNAL MODULE: ./src/utils/orderGSTStatus.js
var orderGSTStatus = __webpack_require__(314723);
// EXTERNAL MODULE: ./src/utils/getStoreType.js
var getStoreType = __webpack_require__(66871);
// EXTERNAL MODULE: ./src/utils/getCustomCtaText.js
var getCustomCtaText = __webpack_require__(336623);
;// CONCATENATED MODULE: ./src/components/MobikwikPayment/index.js

var BTN_STYLES = {
    backgroundColor: "#0C4BFF",
    padding: "14px",
    lineHeight: "24px",
    borderRadius: 12
};
var MobikwikPayment = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pa4 flex flex-column items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "https://cdn.dotpe.in/kiranaStatic/icons/mobikwik_icon.png",
                width: "50%",
                className: "mx-auto"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "w-100 white fw7 ttu f18px bn mt5 pointer",
                style: BTN_STYLES,
                onClick: onClick,
                children: "Pay using Mobikwik"
            })
        ]
    });
};
/* harmony default export */ var components_MobikwikPayment = (MobikwikPayment);

// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.ts
var useFeatureLocks = __webpack_require__(482516);
// EXTERNAL MODULE: ./src/components/DesignSystem/AuthPopUp/index.js + 4 modules
var AuthPopUp = __webpack_require__(493973);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(506337);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(474151);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/GlobalCfeLoader.tsx
var GlobalCfeLoader = __webpack_require__(179220);
// EXTERNAL MODULE: ./src/hooks/useUnselectablePaymentOptions.tsx
var useUnselectablePaymentOptions = __webpack_require__(908623);
// EXTERNAL MODULE: ./src/hooks/usePaymentOptionHandler.tsx
var usePaymentOptionHandler = __webpack_require__(581887);
;// CONCATENATED MODULE: ./src/components/DesktopPaymentModal/index.js
/**
 * Desktop Payment Modal
 */ 


























// import LoaderIcon from '@/components/Common/LoaderIcon';








var DesktopPaymentModal = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var ref7 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), globalStyle = ref7.widgetContextState.globalStyle;
    var orderHashFromParams = router.query.hash;
    var isPaymentPage = router.pathname.includes("/payment/");
    var isOnPendingPaymentPage = orderHashFromParams && isPaymentPage;
    var ref8 = (0,react.useState)({
        payOnDelivery: false,
        selectedOption: null,
        activePaymentMethods: [],
        modalVisible: false,
        showAuthModal: false
    }), state = ref8[0], setState = ref8[1];
    var ref9 = (0,react.useState)(false), toggleState = ref9[0], setToggleState = ref9[1];
    var ref10 = (0,react.useState)(0), payAmount = ref10[0], setPayAmount = ref10[1];
    var ref11 = (0,react.useState)(0), codCharge = ref11[0], setCodCharge = ref11[1];
    var ref12 = (0,react.useState)(constants/* PARTIAL_PAYMENT_OPTION.FULL_PAYMENT */.j6.FULL_PAYMENT), selectedPartialPaymentMode = ref12[0], setSelectedPartialPaymentMode = ref12[1];
    var partialPaymentFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().partialPaymentFeatureStatus;
    var onCashOptionHandle = (0,usePaymentOptionHandler/* usePaymentOptionHandler */.g)().onCashOptionHandle;
    var partialPaymentFeatureVisible = partialPaymentFeatureStatus === null || partialPaymentFeatureStatus === void 0 ? void 0 : partialPaymentFeatureStatus.isVisible;
    var ref13 = (0,es/* useSelector */.v9)(function(state) {
        var userReducer = state.userReducer;
        return {
            theme: state.storeReducer.store.theme,
            services: state.storeReducer.store.services,
            paymentModalVisibility: state.commonReducer.paymentModalVisibility,
            orderDetails: state.orderReducer.orderDetails,
            storeInfo: state.storeReducer.store,
            paymentMethods: state.paymentReducer.methods,
            downPaymentMethods: state.paymentReducer.downPaymentMethods,
            otherMethods: state.paymentReducer.otherMethods,
            cart: state.cartReducer,
            paymentOptionsWithTxnCharge: state.paymentReducer.paymentOptionsWithTxnCharge,
            paymentMethod: state.paymentReducer.selectedPaymentOptionForMobilePayment,
            minEmiAmount: state.paymentReducer.min_emi_amount,
            userData: state.userReducer.data,
            userReducer: userReducer,
            partial_payment_amount: state.paymentReducer.partial_payment_amount,
            paymentModalOptionsVisibility: state.commonReducer.paymentModalOptionsVisibility
        };
    }), theme = ref13.theme, paymentModalVisibility = ref13.paymentModalVisibility, orderDetails = ref13.orderDetails, storeInfo = ref13.storeInfo, paymentMethods = ref13.paymentMethods, downPaymentMethods = ref13.downPaymentMethods, otherMethods = ref13.otherMethods, cart = ref13.cart, paymentOptionsWithTxnCharge = ref13.paymentOptionsWithTxnCharge, paymentMethod = ref13.paymentMethod, minEmiAmount = ref13.minEmiAmount, userReducer = ref13.userReducer, userData = ref13.userData, partial_payment_amount = ref13.partial_payment_amount, paymentModalOptionsVisibility = ref13.paymentModalOptionsVisibility, services = ref13.services;
    var finalUnselectablePaymentOptions = (0,useUnselectablePaymentOptions/* default */.Z)().finalUnselectablePaymentOptions;
    var checkIfMDRActive = (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.mdr_flag) === 1;
    var requireUserLogin = (0,react.useMemo)(function() {
        if (!isOnPendingPaymentPage || checkRenderEnv/* IS_SERVER */.W6 || (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.phone) == "0000000000") return false;
        var authToken = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("auth_token");
        if (authToken && !(userData === null || userData === void 0 ? void 0 : userData.phone)) return false;
        if (!(userReducer === null || userReducer === void 0 ? void 0 : userReducer.isLogin)) return true;
        if (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.phone) return (userData === null || userData === void 0 ? void 0 : userData.phone) !== (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.phone);
        return false;
    }, [
        orderDetails,
        userReducer,
        checkRenderEnv/* IS_SERVER */.W6
    ]);
    (0,react.useEffect)(function() {
        if (isOnPendingPaymentPage) {
            var authToken = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("auth_token");
            if (authToken && !(userData === null || userData === void 0 ? void 0 : userData.phone)) {
                var authData = {
                    auth_token: authToken,
                    service: ""
                };
                dispatch((0,auth/* authenticateUser */.So)(authData));
            }
        }
        setCodCharge(_getCODCharges(orderDetails, services));
    }, []);
    (0,react.useEffect)(function() {
        if (requireUserLogin && !state.showAuthModal) {
            toggleAuthModal();
        }
    }, [
        requireUserLogin,
        state.showAuthModal
    ]);
    (0,react.useEffect)(function() {
        dispatch((0,common/* setPaymentModalOptionsVisiblity */.O1)(true));
        if (paymentModalVisibility && !state.modalVisible) {
            (storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id) && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash) && dispatch((0,payment/* fetchPaymentMethods */.F7)({
                store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                hash: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash
            }));
            if ((orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.parent_order_id) !== 0 && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.partial_payment_type) > 0) {
                dispatch((0,order/* fetchOrderDetailByID */.GW)({
                    order_id: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.parent_order_id
                }));
            }
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    modalVisible: true
                });
            });
        }
        if (!paymentModalVisibility) {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    modalVisible: false
                });
            });
        }
        setCodCharge(_getCODCharges(orderDetails, services));
    }, [
        paymentModalVisibility,
        storeInfo,
        orderDetails
    ]);
    (0,react.useEffect)(function() {
        if (paymentMethod && Object.keys(paymentMethod).length) {
            setPayAmount(paymentMethod.pay_amount);
        }
    }, [
        paymentMethod
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (paymentModalVisibility && ((ref = cart.payment_offer) === null || ref === void 0 ? void 0 : ref.payment_method)) {
            var ref1, ref2, ref3;
            var paymentMethod = ((ref1 = cart.payment_offer) === null || ref1 === void 0 ? void 0 : ref1.payment_method) === constants/* PAYMENT_TYPE_CONSTANTS.DEBIT_CARD */.Mf.DEBIT_CARD || ((ref2 = cart.payment_offer) === null || ref2 === void 0 ? void 0 : ref2.payment_method) === constants/* PAYMENT_TYPE_CONSTANTS.CREDIT_CARD */.Mf.CREDIT_CARD ? constants/* PAYMENT_TYPE_CONSTANTS.CARD */.Mf.CARD : (ref3 = cart.payment_offer) === null || ref3 === void 0 ? void 0 : ref3.payment_method;
            submitPayment(paymentMethod, true); // UPI payment activation
        }
    }, [
        paymentModalVisibility
    ]);
    (0,react.useEffect)(function() {
        var tempState = {};
        tempState.activePaymentMethods = [];
        tempState.selectedOption = null;
        var methods = [];
        /**
     * If mdr_flag == 1 (customer pays transaction charges)
     * get payment methods from paymentOptionsWithTxnCharge key in paymentReducer
     * otherwise go with normal flow
     */ if (checkIfMDRActive && (0,checkIfObjectExists/* checkIfObjectExists */.L)(paymentOptionsWithTxnCharge !== null && paymentOptionsWithTxnCharge !== void 0 ? paymentOptionsWithTxnCharge : {})) {
            var down_payment_modes = paymentOptionsWithTxnCharge.down_payment_modes, others = paymentOptionsWithTxnCharge.others, payment_modes = paymentOptionsWithTxnCharge.payment_modes;
            /**
       * Take all the keys from paymentOptionsWithTxnCharge
       * and take out only the value of 'payment_option_name' key
       */ methods = (0,_to_consumable_array/* default */.Z)(payment_modes || []).concat((0,_to_consumable_array/* default */.Z)(down_payment_modes || []), (0,_to_consumable_array/* default */.Z)(others || [])).map(function(method) {
                if (method.hasOwnProperty("payment_option_name")) return method["payment_option_name"];
            });
        } else if ((paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.length) || (downPaymentMethods === null || downPaymentMethods === void 0 ? void 0 : downPaymentMethods.length) || (otherMethods === null || otherMethods === void 0 ? void 0 : otherMethods.length)) {
            methods = (0,_to_consumable_array/* default */.Z)(paymentMethods).concat((0,_to_consumable_array/* default */.Z)(downPaymentMethods), (0,_to_consumable_array/* default */.Z)(otherMethods));
        }
        if (methods.includes(constants/* PAYMENT_TYPE_CONSTANTS.GOOGLE_PAY */.Mf.GOOGLE_PAY) || methods.includes(constants/* PAYMENT_TYPE_CONSTANTS.PHONEPE */.Mf.PHONEPE) || methods.includes(constants/* PAYMENT_TYPE_CONSTANTS.PAYTM_UPI */.Mf.PAYTM_UPI)) {
            tempState.activePaymentMethods.push(constants/* ACTIVE_PAYMENT_METHOD.UPI */.Tb.UPI);
            if (paymentModalVisibility && checkForInvalidAmount()) {
                tempState.selectedOption = constants/* ACTIVE_PAYMENT_METHOD.CASH */.Tb.CASH;
            } else tempState.selectedOption = constants/* ACTIVE_PAYMENT_METHOD.UPI */.Tb.UPI;
            /**
       * If mdr_flag == 1, send data of first payment_method
       * to reducer to be used later
       */ if (checkIfMDRActive) {
                var payment_modes1 = paymentOptionsWithTxnCharge.payment_modes;
                var ref;
                if (payment_modes1 === null || payment_modes1 === void 0 ? void 0 : payment_modes1.length) dispatch((0,payment/* setCustomerTransactionPaymentMethod */.j1)((ref = payment_modes1[0]) !== null && ref !== void 0 ? ref : {}));
            }
        }
        /**
     * if mdr_flag == 1, show CC and DC
     * otherwise show common CC-DC component
     */ if (checkIfMDRActive && (methods.includes(constants/* PAYMENT_TYPE_CONSTANTS.CREDIT_CARD */.Mf.CREDIT_CARD) || methods.includes(constants/* PAYMENT_TYPE_CONSTANTS.DEBIT_CARD */.Mf.DEBIT_CARD))) {
            /**
       * when mdr_flag == 1, CC and DC have separate txnm charges
       * so have to be shown separately
       */ if (methods.includes(constants/* PAYMENT_TYPE_CONSTANTS.CREDIT_CARD */.Mf.CREDIT_CARD)) tempState.activePaymentMethods.push(constants/* ACTIVE_PAYMENT_METHOD.CREDIT_CARD */.Tb.CREDIT_CARD);
            if (methods.includes(constants/* PAYMENT_TYPE_CONSTANTS.DEBIT_CARD */.Mf.DEBIT_CARD)) tempState.activePaymentMethods.push(constants/* ACTIVE_PAYMENT_METHOD.DEBIT_CARD */.Tb.DEBIT_CARD);
        } else {
            if (methods.includes(constants/* PAYMENT_TYPE_CONSTANTS.CARD */.Mf.CARD)) {
                tempState.activePaymentMethods.push(constants/* ACTIVE_PAYMENT_METHOD.CARD */.Tb.CARD);
            }
        }
        if (methods.includes(constants/* PAYMENT_TYPE_CONSTANTS.LAZYPAY */.Mf.LAZYPAY)) {
            tempState.activePaymentMethods.push(constants/* ACTIVE_PAYMENT_METHOD.LAZYPAY */.Tb.LAZYPAY);
        }
        if (methods.includes(constants/* PAYMENT_TYPE_CONSTANTS.COD */.Mf.COD)) {
            tempState.activePaymentMethods.push(constants/* ACTIVE_PAYMENT_METHOD.CASH */.Tb.CASH);
        }
        if (methods.includes(constants/* PAYMENT_TYPE_CONSTANTS.EMI */.Mf.EMI)) {
            tempState.activePaymentMethods.push(constants/* ACTIVE_PAYMENT_METHOD.EMI */.Tb.EMI);
        }
        if (methods.includes(constants/* PAYMENT_TYPE_CONSTANTS.MOBIKWIK */.Mf.MOBIKWIK)) {
            tempState.activePaymentMethods.push(constants/* ACTIVE_PAYMENT_METHOD.MOBIKWIK */.Tb.MOBIKWIK);
        }
        setState(function(state) {
            return (0,_object_spread/* default */.Z)({}, state, tempState);
        });
    }, [
        paymentMethods,
        downPaymentMethods,
        otherMethods,
        paymentOptionsWithTxnCharge
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (paymentModalVisibility && !(cart === null || cart === void 0 ? void 0 : (ref = cart.payment_offer) === null || ref === void 0 ? void 0 : ref.payment_method)) {
            var ref1;
            dispatch((0,logs/* pushEventsLog */.U)({
                event_name: "Cx_Payment_Init",
                data: {
                    store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                    domain: storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain,
                    device: deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf ? "Mobile" : "Desktop",
                    cx_number: userData === null || userData === void 0 ? void 0 : userData.phone
                }
            }));
        }
    }, [
        paymentModalVisibility,
        cart === null || cart === void 0 ? void 0 : (ref1 = cart.payment_offer) === null || ref1 === void 0 ? void 0 : ref1.payment_method
    ]);
    var toggleAuthModal = function() {
        if (!requireUserLogin) {
            setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showAuthModal: false
            }));
        } else {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    showAuthModal: !state.showAuthModal
                });
            });
        }
    };
    var submitPayment = function(method) {
        var isPaymentPromoPresent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var ref;
        var payload = {
            orderID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash,
            paymentMethod: method,
            phone: userData === null || userData === void 0 ? void 0 : userData.phone,
            merchantID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.merchant_id,
            deviceType: (0,deviceInfo/* getDeviceInfo */.d)().OSName,
            browserType: (0,deviceInfo/* getDeviceInfo */.d)().BrowserName,
            userAgent: (0,deviceInfo/* getDeviceInfo */.d)().userAgent,
            source: "longtail",
            merchantName: "Digital Showroom - ".concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.name)
        };
        dispatch((0,payment/* savePaymentInfo */.YI)(payload));
        if (isPaymentPromoPresent) {
            var ref1;
            payload["promoCode"] = cart === null || cart === void 0 ? void 0 : (ref1 = cart.payment_offer) === null || ref1 === void 0 ? void 0 : ref1.promo_code;
        }
        if (method === constants/* PAYMENT_TYPE_CONSTANTS.CARD */.Mf.CARD && !isPaymentPromoPresent) {
            var ref2;
            router.push((0,routes.getRoute)(routes.PATH.cardPayment(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash), storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.store_info) === null || ref2 === void 0 ? void 0 : ref2.domain));
            return;
        }
        dispatch((0,payment/* initPayment */.yK)(payload, router));
        localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("orderID", orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash);
    };
    var onClose = function() {
        if (props.behaveAsPaymentPage) {
            return;
        }
        setSelectedPartialPaymentMode(constants/* PARTIAL_PAYMENT_OPTION.FULL_PAYMENT */.j6.FULL_PAYMENT);
        dispatch((0,common/* setPaymentModalVisiblity */.Tc)(false));
        dispatch((0,common/* setPaymentModalOptionsVisiblity */.O1)(true));
    };
    var toggleSelectedOption = function(option, txnType) {
        var mdrValid = true;
        if (option === state.selectedOption) return;
        if (checkForInvalidAmount()) {
            (0,Toast/* toastNotifyError */.Lu)((0,getPrepaidInvalidAmountMessage/* getPrepaidInvalidAmountMessage */.a)((0,getStoreType/* getStoreType */.K)()));
            return;
        }
        /*
      MDR and ERI options are exclusive now.
      So if EMI option is selected then, 
      prePaymentCheckMDRTransactions is now not required.

      if emi payment method selected, then we can avoid using the 
      prePaymentCheckMDRTransactions api.
    */ if (checkIfMDRActive && (0,checkIfObjectExists/* checkIfObjectExists */.L)(txnType)) {
            var payload = {
                order_hash: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash,
                store_id: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.store_id,
                payment_option: txnType
            };
            var callback = function(status) {
                mdrValid = status;
                var oldSelectedState = (0,_object_spread/* default */.Z)({}, state);
                if (!mdrValid) {
                    setState(oldSelectedState);
                }
            };
            (0,es/* batch */.dC)(function() {
                dispatch((0,payment/* setCustomerTransactionPaymentMethod */.j1)(txnType));
                dispatch((0,payment/* prePaymentCheckMDRTransactions */.HV)(payload, callback));
            });
        }
        if (mdrValid) {
            if (option === constants/* ACTIVE_PAYMENT_METHOD.LAZYPAY */.Tb.LAZYPAY) {
                var ref;
                var payload1 = {
                    orderID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash,
                    paymentMethod: "lazyPay",
                    merchantID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.merchant_id,
                    deviceType: (0,deviceInfo/* getDeviceInfo */.d)().OSName,
                    browserType: (0,deviceInfo/* getDeviceInfo */.d)().BrowserName,
                    userAgent: (0,deviceInfo/* getDeviceInfo */.d)().userAgent,
                    source: "longtail",
                    merchantName: "Digital Showroom - ".concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.name)
                };
                dispatch((0,payment/* savePaymentInfo */.YI)(payload1));
                payload1.phone = orderDetails.phone;
                payload1.amount = checkIfMDRActive ? txnType.pay_amount : orderDetails.amount;
                payload1.store_id = orderDetails.store_id;
                dispatch((0,payment/* initLazyPayPayment */.q)(payload1));
            }
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    selectedOption: option
                });
            });
        }
    };
    /**
   * function return payment amount strip
   * @return {JSX}
   */ var _renderPaymentAmtStrip = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: "pv3 bg-black-10 fw6 f4 br--top br4 tc flex flex-column items-center justiyf-center",
            children: [
                "Pay ₹ ",
                checkIfMDRActive ? payAmount : orderDetails.buyer_pay_value,
                [
                    constants/* ACTIVE_PAYMENT_METHOD.CREDIT_CARD */.Tb.CREDIT_CARD
                ].includes(state.selectedOption) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "card-payment-exceptions mt2",
                    children: "For Amex Cards, convenience fee will be 2.7%"
                })
            ]
        });
    };
    var returnTransactionPercent = function(value) {
        var payment_modes = paymentOptionsWithTxnCharge.payment_modes, others = paymentOptionsWithTxnCharge.others;
        var combinedArr = (0,_to_consumable_array/* default */.Z)(payment_modes || []).concat((0,_to_consumable_array/* default */.Z)(others || []));
        var txnType = combinedArr.find(function(item) {
            return item.payment_option_name.toLowerCase() === value.toLowerCase();
        });
        return (txnType === null || txnType === void 0 ? void 0 : txnType.transaction_charge) || "0";
    };
    var sendTransactionTypeToState = function(value) {
        var searchValue = value === constants/* ACTIVE_PAYMENT_METHOD.UPI */.Tb.UPI ? constants/* PAYMENT_TYPE_CONSTANTS.GOOGLE_PAY */.Mf.GOOGLE_PAY : value.toLowerCase();
        if (paymentOptionsWithTxnCharge && Object.keys(paymentOptionsWithTxnCharge).length) {
            var payment_modes = paymentOptionsWithTxnCharge.payment_modes, others = paymentOptionsWithTxnCharge.others;
            var combinedArr = (0,_to_consumable_array/* default */.Z)(payment_modes || []).concat((0,_to_consumable_array/* default */.Z)(others || []));
            var txnType = combinedArr.find(function(item) {
                return item.payment_option_name.toLowerCase() === searchValue;
            });
            return txnType || null;
        }
    };
    var CashPayment = function() {
        var ref, ref1;
        if (Number(services === null || services === void 0 ? void 0 : services.cod_charge_flag) > constants/* COD_CHARGE_TYPE.FREE */.VV.FREE) {
            var ref2;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "extra-cod-charge-container ".concat(state.selectedOption === constants/* ACTIVE_PAYMENT_METHOD.CASH */.Tb.CASH ? "db" : "dn"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "header",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "header-text",
                            children: "Total amount to be paid: ₹".concat(Number(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.pay_amount) + Number(codCharge))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cost-breakup",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cost-breakup-info",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "cost-breakup-sub-info",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "cost-breakup-sub-info-detail",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-text",
                                                    children: "Item total"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-value",
                                                    children: "₹ ".concat((ref2 = getItemTotal(orderDetails)) === null || ref2 === void 0 ? void 0 : ref2.toFixed(2))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "cost-breakup-sub-info-detail",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-text",
                                                    children: "Delivery Fees"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-value",
                                                    children: "₹ ".concat(Number(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.delivery_charge))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "cost-breakup-sub-info-detail",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-text",
                                                    children: "Extra Charges for Cash On Delivery"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-value",
                                                    children: "₹ ".concat(codCharge)
                                                })
                                            ]
                                        }),
                                        (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.extra_charges) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "cost-breakup-sub-info-detail",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "cost-breakup-sub-info-detail-text",
                                                    children: [
                                                        orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.extra_charge_name.substr(0, 20),
                                                        (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.extra_charge_name.length) > 20 && "..."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-value",
                                                    children: "₹ ".concat(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.extra_charges)
                                                })
                                            ]
                                        }),
                                        (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.discount) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "cost-breakup-sub-info-detail",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-text",
                                                    children: "Discount"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-value",
                                                    children: "- ₹ ".concat(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.discount)
                                                })
                                            ]
                                        }),
                                        (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.promo_discount) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "cost-breakup-sub-info-detail",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-text",
                                                    children: "Promo Discount"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-value",
                                                    children: "- ₹ ".concat(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.promo_discount)
                                                })
                                            ]
                                        }),
                                        (0,orderGSTStatus/* isOrderGstExcluded */.e)() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "cost-breakup-sub-info-detail",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-text",
                                                    children: "GST"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-value",
                                                    children: "₹ ".concat(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.total_gst_paid)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "break-line",
                                    style: {
                                        backgroundColor: "black",
                                        height: "1px",
                                        width: "100%"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "grand-total",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "grand-total-text",
                                            children: [
                                                "Grand Total",
                                                (0,orderGSTStatus/* isOrderGstIncluded */.S)() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "incl-gst responsive-minor-text fw4 ml6px",
                                                    children: [
                                                        "(Incl. ₹ ",
                                                        orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.total_gst_paid,
                                                        " GST)"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "grand-total-value",
                                            children: "₹ ".concat(Number(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.pay_amount) + Number(codCharge))
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "confirm-cod-btn pointer",
                        onClick: function() {
                            return onCashOptionHandle();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "confirm-cod-btn-text",
                            children: "Place Cash on Delivery Order"
                        })
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat(state.selectedOption === constants/* ACTIVE_PAYMENT_METHOD.CASH */.Tb.CASH ? "flex" : "dn", " flex-column justify-center items-center h-100"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tc f6 pb3",
                    children: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.prepaid_flag) === 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "You have to Pay"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "fw6 mh2",
                                children: [
                                    "₹ ",
                                    orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.buyer_pay_value
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "at the time of",
                                    " ",
                                    (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_type) === constants/* ORDER_TYPE.SERVICE */.Jm.SERVICE ? "Service" : orderDetails.order_type === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY ? "Delivery" : "Pick Up"
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "pv3 bn white fw6 w-70",
                    onClick: onCashOptionHandle,
                    style: {
                        backgroundColor: (theme === null || theme === void 0 ? void 0 : (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.primary_color) ? theme === null || theme === void 0 ? void 0 : (ref1 = theme.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color : "#EA5151",
                        borderRadius: theme ? "".concat((0,util/* roundnessCalculator */.M)(theme === null || theme === void 0 ? void 0 : theme.roundness)) : "8px"
                    },
                    children: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.prepaid_flag) === 1 ? (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_type) === constants/* ORDER_TYPE.SERVICE */.Jm.SERVICE ? "Confirm Booking" : "Place Order" : "Request Cash Payment"
                })
            ]
        });
    };
    /**
   * Function check which payment option
   * is checked and return thier view
   * @param {String} type
   * @return {JSX}
   */ var _renderPaymentBlock = function(type) {
        switch(type){
            case constants/* ACTIVE_PAYMENT_METHOD.UPI */.Tb.UPI:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: state.selectedOption === constants/* ACTIVE_PAYMENT_METHOD.UPI */.Tb.UPI ? "db" : "dn",
                    children: [
                        _renderPaymentAmtStrip(),
                        !checkForInvalidAmount() && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_QRPaymentUPI, {
                            partial_payment: toggleState,
                            txnData: sendTransactionTypeToState(constants/* PAYMENT_TYPE_CONSTANTS.PHONEPE */.Mf.PHONEPE) // Use any UPI company for transaction amount
                        })
                    ]
                });
            case constants/* ACTIVE_PAYMENT_METHOD.CREDIT_CARD */.Tb.CREDIT_CARD:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: state.selectedOption === constants/* ACTIVE_PAYMENT_METHOD.CREDIT_CARD */.Tb.CREDIT_CARD ? "db" : "dn",
                    children: [
                        _renderPaymentAmtStrip(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardPaymentBox/* default */.Z, {})
                    ]
                });
            case constants/* ACTIVE_PAYMENT_METHOD.DEBIT_CARD */.Tb.DEBIT_CARD:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: state.selectedOption === constants/* ACTIVE_PAYMENT_METHOD.DEBIT_CARD */.Tb.DEBIT_CARD ? "db" : "dn",
                    children: [
                        _renderPaymentAmtStrip(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardPaymentBox/* default */.Z, {})
                    ]
                });
            case constants/* ACTIVE_PAYMENT_METHOD.CARD */.Tb.CARD:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: state.selectedOption === constants/* ACTIVE_PAYMENT_METHOD.CARD */.Tb.CARD ? "db" : "dn",
                    children: [
                        _renderPaymentAmtStrip(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardPaymentBox/* default */.Z, {})
                    ]
                });
            case constants/* ACTIVE_PAYMENT_METHOD.LAZYPAY */.Tb.LAZYPAY:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: state.selectedOption === constants/* ACTIVE_PAYMENT_METHOD.LAZYPAY */.Tb.LAZYPAY ? "db" : "dn",
                    children: [
                        _renderPaymentAmtStrip(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pa3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lazyPayAuth/* default */.Z, {
                                isDesktop: true
                            })
                        })
                    ]
                });
            case constants/* ACTIVE_PAYMENT_METHOD.CASH */.Tb.CASH:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CashPayment, {});
            case constants/* ACTIVE_PAYMENT_METHOD.EMI */.Tb.EMI:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: state.selectedOption === constants/* ACTIVE_PAYMENT_METHOD.EMI */.Tb.EMI ? "db" : "dn",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pa4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmiCardPayment/* default */.Z, {})
                    })
                });
            case constants/* ACTIVE_PAYMENT_METHOD.MOBIKWIK */.Tb.MOBIKWIK:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: state.selectedOption === constants/* ACTIVE_PAYMENT_METHOD.MOBIKWIK */.Tb.MOBIKWIK ? "db" : "dn",
                    children: [
                        _renderPaymentAmtStrip(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MobikwikPayment, {
                            onClick: function() {
                                submitPayment(constants/* PAYMENT_TYPE_CONSTANTS.MOBIKWIK */.Mf.MOBIKWIK);
                            }
                        })
                    ]
                });
            default:
                return null;
        }
    };
    /**
   * Function for getting the
   * Payment option item card
   * @param {Object} param
   * @return {JSX}
   */ var _renderPaymentOptionItem = function(param) {
        var title = param.title, option = param.option, images = param.images, hasImages = param.hasImages, _transactionAmt = param.transactionAmt, transactionAmt = _transactionAmt === void 0 ? false : _transactionAmt, _txnType = param.txnType, txnType = _txnType === void 0 ? null : _txnType, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: "option-card ".concat(customClasses, " ").concat(state.selectedOption === option ? "selected" : ""),
            onClick: function() {
                return toggleSelectedOption(option, txnType);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "input-wrap",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomRadio/* default */.Z, {
                                className: "slimy-green-color",
                                type: "radio",
                                checked: state.selectedOption === option,
                                "aria-checked": state.selectedOption === option
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "content-wrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                    className: "fw5",
                                    children: title
                                }),
                                option === constants/* ACTIVE_PAYMENT_METHOD.CASH */.Tb.CASH && (services === null || services === void 0 ? void 0 : services.cod_charge_flag) > constants/* COD_CHARGE_TYPE.FREE */.VV.FREE && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "extra-cod-charges",
                                    style: {
                                        marginTop: "4px"
                                    },
                                    children: "Extra Charges ₹ ".concat(codCharge)
                                }),
                                hasImages && /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                    className: "icons-wrap",
                                    children: images.map(function(image, idx) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: image
                                            })
                                        }, "option-icons-".concat(idx));
                                    })
                                })
                            ]
                        })
                    ]
                }),
                minEmiAmount > 0 && constants/* ACTIVE_PAYMENT_METHOD.EMI.substring */.Tb.EMI.substring(1).toLowerCase() === title.toLowerCase() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "transaction-charge-text",
                    style: {
                        marginTop: 0
                    },
                    children: [
                        "EMI starts at ₹",
                        minEmiAmount,
                        "/month"
                    ]
                }) : null,
                checkIfMDRActive && (transactionAmt || transactionAmt === 0) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "transaction-charge-text",
                    children: [
                        transactionAmt,
                        "% convenience fee"
                    ]
                }) : null
            ]
        });
    };
    var _renderUnselectablePaymentOptions = function() {
        var isCodDisabledDueToCoupon = finalUnselectablePaymentOptions === null || finalUnselectablePaymentOptions === void 0 ? void 0 : finalUnselectablePaymentOptions.includes(constants/* PAYMENT_TYPE_CONSTANTS.COD */.Mf.COD);
        return !!finalUnselectablePaymentOptions.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "f6 pb3",
                    children: "Other Modes"
                }),
                finalUnselectablePaymentOptions.map(function(paymentOption, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-pointer-events-none tw-opacity-40",
                        children: [
                            _renderPaymentOptionItem({
                                title: (0,getCustomCtaText/* default */.Z)("other_payment_modes_cta"),
                                option: paymentOption,
                                customClasses: "!tw-m-0"
                            }),
                            isCodDisabledDueToCoupon && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "tw-m-0 tw-pt-[8px] tw-text-[11px]/[15px] tw-text-[#111C36CC] ",
                                children: "You cannot select this option, the applied offer is not applicable on ‘Pay on Delivery’ orders."
                            })
                        ]
                    }, index);
                })
            ]
        });
    };
    var cardRenderSection = function() {
        if (checkIfMDRActive) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    state.activePaymentMethods.includes(constants/* ACTIVE_PAYMENT_METHOD.CREDIT_CARD */.Tb.CREDIT_CARD) && _renderPaymentOptionItem({
                        title: "Credit Card",
                        option: constants/* ACTIVE_PAYMENT_METHOD.CREDIT_CARD */.Tb.CREDIT_CARD,
                        hasImages: true,
                        images: [
                            "https://cdn.dotpe.in/longtail/themes/8073865/VBJPyYpp.webp",
                            "https://cdn.dotpe.in/longtail/themes/8073865/KZMw0wjW.webp", 
                        ],
                        transactionAmt: returnTransactionPercent(constants/* ACTIVE_PAYMENT_METHOD.CREDIT_CARD */.Tb.CREDIT_CARD),
                        txnType: sendTransactionTypeToState(constants/* ACTIVE_PAYMENT_METHOD.CREDIT_CARD */.Tb.CREDIT_CARD)
                    }),
                    state.activePaymentMethods.includes(constants/* ACTIVE_PAYMENT_METHOD.DEBIT_CARD */.Tb.DEBIT_CARD) && _renderPaymentOptionItem({
                        title: "Debit Card",
                        option: constants/* ACTIVE_PAYMENT_METHOD.DEBIT_CARD */.Tb.DEBIT_CARD,
                        hasImages: true,
                        images: [
                            "https://cdn.dotpe.in/longtail/themes/8073865/VBJPyYpp.webp",
                            "https://cdn.dotpe.in/longtail/themes/8073865/KZMw0wjW.webp", 
                        ],
                        transactionAmt: returnTransactionPercent(constants/* ACTIVE_PAYMENT_METHOD.DEBIT_CARD */.Tb.DEBIT_CARD),
                        txnType: sendTransactionTypeToState(constants/* ACTIVE_PAYMENT_METHOD.DEBIT_CARD */.Tb.DEBIT_CARD)
                    })
                ]
            });
        } else {
            return state.activePaymentMethods.includes(constants/* ACTIVE_PAYMENT_METHOD.CARD */.Tb.CARD) && _renderPaymentOptionItem({
                title: "Credit & Debit Cards",
                option: constants/* ACTIVE_PAYMENT_METHOD.CARD */.Tb.CARD,
                hasImages: true,
                images: [
                    "https://cdn.dotpe.in/longtail/themes/8073865/VBJPyYpp.webp",
                    "https://cdn.dotpe.in/longtail/themes/8073865/KZMw0wjW.webp", 
                ]
            });
        }
    };
    var checkForCashPayment = function() {
        var ref;
        return state.activePaymentMethods.includes(constants/* ACTIVE_PAYMENT_METHOD.CASH */.Tb.CASH) && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.payment_method) !== constants/* PREPAID_POSTPAID_METHODS.PREPAID */.R9.PREPAID && selectedPartialPaymentMode !== constants/* PARTIAL_PAYMENT_OPTION.PARTIAL_PAYMENT */.j6.PARTIAL_PAYMENT;
    };
    var handleInputRadioClick = function(type) {
        // if user is clicking same input radio again n again, don't allow any network call.
        if (type === selectedPartialPaymentMode) return;
        dispatch((0,common/* setPaymentModalOptionsVisiblity */.O1)(false));
        var payload = {
            store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
            order_id: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_id,
            part_payment_option: type,
            pay_amount: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.pay_amount
        };
        dispatch((0,payment/* togglePartialPaymentMode */.bj)(payload, function() {
            setToggleState(!toggleState);
            dispatch((0,order/* fetchOrderByHash */.yZ)({
                order_hash: orderDetails.order_hash,
                isPrepaid: 1
            }));
            dispatch((0,payment/* fetchPaymentMethods */.F7)({
                store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                hash: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash
            }));
            dispatch((0,common/* setPaymentModalOptionsVisiblity */.O1)(true));
        }, function() {
            setSelectedPartialPaymentMode(type);
        }));
    };
    var isPartialPaymentToggleNotAllowed = function() {
        if (partial_payment_amount < constants/* MINIMUM_ORDER_AMOUNT */.BI) {
            return true;
        }
        if (checkIfMDRActive) {
            return partial_payment_amount >= payAmount;
        } else {
            return partial_payment_amount >= orderDetails.buyer_pay_value;
        }
    };
    var renderPartialPaymentComponent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "partial-payment-section",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "title",
                    children: "Select a payment method"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "radio-input-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "radio-input-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomRadio/* default */.Z, {
                                    type: "radio",
                                    checked: selectedPartialPaymentMode === constants/* PARTIAL_PAYMENT_OPTION.FULL_PAYMENT */.j6.FULL_PAYMENT,
                                    "aria-checked": selectedPartialPaymentMode === constants/* PARTIAL_PAYMENT_OPTION.FULL_PAYMENT */.j6.FULL_PAYMENT,
                                    style: {
                                        width: "20px",
                                        height: "20px",
                                        color: "#3D6AFD",
                                        cursor: "pointer",
                                        border: selectedPartialPaymentMode === constants/* PARTIAL_PAYMENT_OPTION.FULL_PAYMENT */.j6.FULL_PAYMENT ? "" : "0.15em solid #D4D4D5"
                                    },
                                    onClick: function() {
                                        return handleInputRadioClick(constants/* PARTIAL_PAYMENT_OPTION.FULL_PAYMENT */.j6.FULL_PAYMENT);
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "radio-content-wrap",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                        className: "fw5",
                                        children: "Full Payment"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "radio-input-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomRadio/* default */.Z, {
                                    type: "radio",
                                    checked: selectedPartialPaymentMode === constants/* PARTIAL_PAYMENT_OPTION.PARTIAL_PAYMENT */.j6.PARTIAL_PAYMENT,
                                    "aria-checked": selectedPartialPaymentMode === constants/* PARTIAL_PAYMENT_OPTION.PARTIAL_PAYMENT */.j6.PARTIAL_PAYMENT,
                                    style: {
                                        width: "20px",
                                        height: "20px",
                                        color: "#3D6AFD",
                                        cursor: "".concat(isPartialPaymentToggleNotAllowed() ? "not-allowed" : "pointer"),
                                        border: selectedPartialPaymentMode === constants/* PARTIAL_PAYMENT_OPTION.PARTIAL_PAYMENT */.j6.PARTIAL_PAYMENT ? "" : "0.15em solid #D4D4D5"
                                    },
                                    onClick: function() {
                                        return handleInputRadioClick(constants/* PARTIAL_PAYMENT_OPTION.PARTIAL_PAYMENT */.j6.PARTIAL_PAYMENT);
                                    },
                                    disabled: isPartialPaymentToggleNotAllowed()
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "radio-content-wrap",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                            className: "fw5",
                                            children: [
                                                storeInfo.services.partial_payment_flag === 1 ? "".concat(storeInfo.services.partial_payment_value, "% ") : "",
                                                "Partial Payment - Rs. ",
                                                partial_payment_amount
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            loading: "lazy",
                                            src: "/assets/icons/tooltipGrayIcon.svg",
                                            "data-tip": true,
                                            "data-for": "partial-payment-info"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                            id: "partial-payment-info",
                                            place: "bottom",
                                            effect: "solid",
                                            multiline: true,
                                            padding: "8px",
                                            disable: false,
                                            arrowColor: "#4F4F4F",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "mv0 fw5 f12px",
                                                children: [
                                                    "Choose this option to make a partial ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    " payment. The remaining amount will be ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    " collected at the time of delivery/pickup"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            paymentModalVisibility && !(cart === null || cart === void 0 ? void 0 : (ref2 = cart.payment_offer) === null || ref2 === void 0 ? void 0 : ref2.payment_method) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                visible: paymentModalVisibility,
                className: "bottom-modal desktopPaymentModal " + (props.behaveAsPaymentPage ? "desktopPaymentPage" : ""),
                animation: "slideUp",
                customStyles: {
                    maxWidth: "1000px",
                    width: "100%"
                },
                onClose: onClose,
                children: [
                    props.behaveAsPaymentPage ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "closeicon pointer",
                        onClick: onClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            loading: "lazy",
                            src: "https://cdn.dotpe.in/longtail/themes/8073865/9sE359Sh.webp",
                            alt: "cancel"
                        })
                    }),
                    partialPaymentFeatureVisible && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.services) === null || ref3 === void 0 ? void 0 : ref3.partial_payment_flag) && orderDetails.prepaid_flag > 0 && !(orderDetails.parent_order_id !== 0 && orderDetails.partial_payment_type > 0) ? renderPartialPaymentComponent() : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "f4 fw6 pv3 ph2",
                        children: "Select Payment Method"
                    }),
                    !paymentModalOptionsVisibility ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            height: "492px",
                            background: "white",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalCfeLoader/* GlobalCfeLoader */.I, {
                            type: (globalStyle === null || globalStyle === void 0 ? void 0 : (ref4 = globalStyle.appLoader) === null || ref4 === void 0 ? void 0 : ref4.loaderId) || "ellipsis",
                            color: globalStyle === null || globalStyle === void 0 ? void 0 : (ref5 = globalStyle.appLoader) === null || ref5 === void 0 ? void 0 : ref5.color
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "content-grid pb4 ph2 pt3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                className: "pv2 overflow-y-auto",
                                children: [
                                    state.activePaymentMethods.includes(constants/* ACTIVE_PAYMENT_METHOD.UPI */.Tb.UPI) && _renderPaymentOptionItem({
                                        title: "UPI Payments",
                                        option: constants/* ACTIVE_PAYMENT_METHOD.UPI */.Tb.UPI,
                                        hasImages: true,
                                        images: [
                                            "https://cdn.dotpe.in/longtail/themes/8073865/TVi0GjBB.webp",
                                            "https://cdn.dotpe.in/longtail/themes/8073865/N2BcdtfG.webp",
                                            "https://cdn.dotpe.in/longtail/themes/8073865/WZktEt3t.webp", 
                                        ],
                                        transactionAmt: returnTransactionPercent(constants/* PAYMENT_TYPE_CONSTANTS.PHONEPE */.Mf.PHONEPE // Use any UPI company for transaction amount
                                        ),
                                        txnType: sendTransactionTypeToState(constants/* PAYMENT_TYPE_CONSTANTS.PHONEPE */.Mf.PHONEPE)
                                    }),
                                    cardRenderSection(),
                                    state.activePaymentMethods.includes(constants/* ACTIVE_PAYMENT_METHOD.LAZYPAY */.Tb.LAZYPAY) && _renderPaymentOptionItem({
                                        title: "LazyPay",
                                        option: constants/* ACTIVE_PAYMENT_METHOD.LAZYPAY */.Tb.LAZYPAY,
                                        hasImages: true,
                                        images: [
                                            "https://cdn.dotpe.in/longtail/themes/8073865/2qDSXsoj.webp", 
                                        ],
                                        transactionAmt: returnTransactionPercent(constants/* ACTIVE_PAYMENT_METHOD.LAZYPAY */.Tb.LAZYPAY),
                                        txnType: sendTransactionTypeToState(constants/* ACTIVE_PAYMENT_METHOD.LAZYPAY */.Tb.LAZYPAY)
                                    }),
                                    state.activePaymentMethods.includes(constants/* ACTIVE_PAYMENT_METHOD.MOBIKWIK */.Tb.MOBIKWIK) && _renderPaymentOptionItem({
                                        title: "Mobikwik",
                                        option: constants/* ACTIVE_PAYMENT_METHOD.MOBIKWIK */.Tb.MOBIKWIK,
                                        hasImages: true,
                                        images: [
                                            "https://cdn.dotpe.in/kiranaStatic/icons/mobikwik_icon.png"
                                        ],
                                        transactionAmt: returnTransactionPercent(constants/* ACTIVE_PAYMENT_METHOD.MOBIKWIK */.Tb.MOBIKWIK),
                                        txnType: sendTransactionTypeToState(constants/* ACTIVE_PAYMENT_METHOD.MOBIKWIK */.Tb.MOBIKWIK)
                                    }),
                                    state.activePaymentMethods.includes(constants/* ACTIVE_PAYMENT_METHOD.EMI */.Tb.EMI) && _renderPaymentOptionItem({
                                        title: "EMI",
                                        option: constants/* ACTIVE_PAYMENT_METHOD.EMI */.Tb.EMI,
                                        hasImages: true,
                                        images: [],
                                        transactionAmt: 0,
                                        txnType: sendTransactionTypeToState(constants/* ACTIVE_PAYMENT_METHOD.EMI */.Tb.EMI)
                                    }),
                                    state.activePaymentMethods.includes(constants/* ACTIVE_PAYMENT_METHOD.CASH */.Tb.CASH) && ((ref6 = storeInfo.services) === null || ref6 === void 0 ? void 0 : ref6.payment_method) !== 1 && checkForCashPayment() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "f6 pb3",
                                                children: "Other Modes"
                                            }),
                                            _renderPaymentOptionItem({
                                                title: (0,getCustomCtaText/* default */.Z)("other_payment_modes_cta"),
                                                option: constants/* ACTIVE_PAYMENT_METHOD.CASH */.Tb.CASH,
                                                txnType: sendTransactionTypeToState(constants/* PAYMENT_TYPE_CONSTANTS.COD */.Mf.COD),
                                                customClasses: "!tw-m-0"
                                            })
                                        ]
                                    }) : null,
                                    _renderUnselectablePaymentOptions()
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                className: "br4 ba b--black-10 mh-100 overflow-y-auto",
                                children: [
                                    state.activePaymentMethods.includes(constants/* ACTIVE_PAYMENT_METHOD.UPI */.Tb.UPI) && _renderPaymentBlock(constants/* ACTIVE_PAYMENT_METHOD.UPI */.Tb.UPI),
                                    checkIfMDRActive ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            _renderPaymentBlock(constants/* ACTIVE_PAYMENT_METHOD.CREDIT_CARD */.Tb.CREDIT_CARD),
                                            _renderPaymentBlock(constants/* ACTIVE_PAYMENT_METHOD.DEBIT_CARD */.Tb.DEBIT_CARD)
                                        ]
                                    }) : _renderPaymentBlock(constants/* ACTIVE_PAYMENT_METHOD.CARD */.Tb.CARD),
                                    _renderPaymentBlock(constants/* ACTIVE_PAYMENT_METHOD.LAZYPAY */.Tb.LAZYPAY),
                                    _renderPaymentBlock(constants/* ACTIVE_PAYMENT_METHOD.CASH */.Tb.CASH),
                                    _renderPaymentBlock(constants/* ACTIVE_PAYMENT_METHOD.EMI */.Tb.EMI),
                                    _renderPaymentBlock(constants/* ACTIVE_PAYMENT_METHOD.MOBIKWIK */.Tb.MOBIKWIK)
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            state.showAuthModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthPopUp["default"], {
                isVisible: state.showAuthModal,
                toggleModal: toggleAuthModal,
                prefilledPhone: isOnPendingPaymentPage && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.phone) || null,
                sendOTPBeforeHand: isOnPendingPaymentPage
            })
        ]
    });
};
var getItemTotal = function(orderDetails) {
    var ref;
    return orderDetails === null || orderDetails === void 0 ? void 0 : (ref = orderDetails.items) === null || ref === void 0 ? void 0 : ref.reduce(function(acc, curr) {
        if (curr.item_status === 1) acc = acc + curr.amount;
        return acc;
    }, 0);
};
function _getCODCharges(orderDetails, services) {
    var itemsTotal = getItemTotal(orderDetails);
    if ((services === null || services === void 0 ? void 0 : services.cod_charge_flag) === 0 || (services === null || services === void 0 ? void 0 : services.cod_charge_offset_value) !== 0 && (services === null || services === void 0 ? void 0 : services.cod_charge_offset_value) < itemsTotal) {
        return 0;
    }
    if ((services === null || services === void 0 ? void 0 : services.cod_charge_flag) === 1) {
        return services === null || services === void 0 ? void 0 : services.cod_charge_value;
    } else if ((services === null || services === void 0 ? void 0 : services.cod_charge_flag) === 2) {
        return (itemsTotal * (services === null || services === void 0 ? void 0 : services.cod_charge_value) / 100).toFixed(0);
    }
    return 0;
}
/* harmony default export */ var components_DesktopPaymentModal = (DesktopPaymentModal);


/***/ }),

/***/ 829875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(119372);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(225617);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_deviceInfo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(990864);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(913886);
/* harmony import */ var _assets_svgExports_BackArrow__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(285946);
// styling for this component is in emiCardPayment.scss








var rangeOfYears = function() {
    var result = [];
    var min = new Date().getUTCFullYear();
    var max = min + 20;
    while(min <= max){
        result.push("" + min);
        min++;
    }
    return result;
};
var EmiCardPayment = function(param) {
    var _isDesktop = param.isDesktop, isDesktop = _isDesktop === void 0 ? true : _isDesktop;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        cardInformation: {
            cardNumber: "",
            monthSelected: "01",
            yearSelected: rangeOfYears()[0],
            cvv: ""
        },
        cvvLength: 3,
        selectedEmi: {},
        step: 1,
        completedSteps: [],
        cardType: "",
        emiAvailable: true
    }), emiInformation = ref[0];
    var ref1 = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return {
            store: state.storeReducer.store,
            orderDetails: state.orderReducer.orderDetails,
            userData: state.userReducer
        };
    }), userData = ref1.userData, orderDetails = ref1.orderDetails, store = ref1.store;
    var validateAll = function() {
        return true;
    };
    var completeEmiPaymentInit = function() {
        if (validateAll()) {
            var ref, ref1;
            var data = {
                orderID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash,
                paymentMethod: _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .PAYMENT_TYPE_CONSTANTS.EMI */ .Mf.EMI,
                merchantID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.merchant_id,
                deviceType: (0,_utils_deviceInfo__WEBPACK_IMPORTED_MODULE_4__/* .getDeviceInfo */ .d)().OSName,
                browserType: (0,_utils_deviceInfo__WEBPACK_IMPORTED_MODULE_4__/* .getDeviceInfo */ .d)().BrowserName,
                userAgent: (0,_utils_deviceInfo__WEBPACK_IMPORTED_MODULE_4__/* .getDeviceInfo */ .d)().userAgent,
                source: "longtail",
                merchantName: "Digital Showroom - ".concat(store === null || store === void 0 ? void 0 : (ref = store.store_info) === null || ref === void 0 ? void 0 : ref.name),
                emiCode: emiInformation.selectedEmi.emi_code,
                phone: userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.phone
            };
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_7__/* .initPayment */ .yK)(data, router));
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "emiCardPayment",
        children: [
            !isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "page-header flex items-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_BackArrow__WEBPACK_IMPORTED_MODULE_6__/* .BackArrow */ .D, {
                        onClick: function() {
                            return router.back();
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "header-text ml3 fw6",
                        children: "EMI"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                onClick: completeEmiPaymentInit,
                className: "tw-w-full tw-cursor-pointer !tw-rounded-[12px] tw-bg-black tw-p-3 tw-font-inter tw-text-lg tw-text-white",
                children: "Continue"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EmiCardPayment);


/***/ }),

/***/ 514456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(119372);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(913886);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(667294);
/* harmony import */ var react_otp_input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(671470);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(225617);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(186812);










var LazyPayAuth = function(props) {
    var timerID = null;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        phone: "",
        OTP: "",
        OTPsent: false,
        timer: 59,
        isTimeUp: false,
        showIncorrectOtpErr: false
    }), state = ref[0], setState = ref[1];
    var ref1 = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
        return {
            lazyPayAuthModal: state.commonReducer.lazyPayAuthModal,
            paymentInfo: state.paymentReducer.paymentInfo
        };
    }), lazyPayAuthModal = ref1.lazyPayAuthModal, paymentInfo = ref1.paymentInfo;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (lazyPayAuthModal.show && lazyPayAuthModal.view === _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .LAZYPAY_AUTH_MODAL_VIEWS.OTP */ .eS.OTP) {
            setState(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                    OTPsent: true
                });
            });
        }
    }, [
        lazyPayAuthModal.show
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (state.OTPsent) {
            startTimer();
        }
        return function() {
            /** Clear the Inteeval if any */ if (timerID != null) {
                clearInterval(timerID);
            }
        };
    }, [
        state.OTPsent
    ]);
    // Start the timmer
    var startTimer = function() {
        var seconds = state.timer;
        timerID = setInterval(function() {
            return tick(--seconds);
        }, 1000);
    };
    // Increase the timing (second) tick
    var tick = function(seconds) {
        var updatedTime;
        if (seconds > 0) {
            updatedTime = (seconds < 10 ? "0" : "") + String(seconds);
            setState(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                    timer: updatedTime
                });
            });
        } else {
            clearInterval(timerID);
            setState(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                    timer: 59,
                    isTimeUp: true
                });
            });
        }
    };
    var resendOTP = function() {
        if (!state.isTimeUp) return;
        setState(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                isTimeUp: false
            });
        });
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_9__/* .initLazyPayPayment */ .q)(paymentInfo));
        var seconds = state.timer;
        timerID = setInterval(function() {
            return tick(--seconds);
        }, 1000);
    };
    var handleChange = function(val) {
        setState(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                OTP: val
            });
        });
    };
    var onPayBtnHandle = function() {
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_9__/* .verifyLazyPayOtp */ .NZ)({
            transactionId: sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .TRANSACTION_ID_CONSTANT */ .eC),
            otp: state.OTP,
            requestType: "pay"
        }, router));
    };
    var _renderNotEligibleView = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "mv0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/2qDSXsoj.webp",
                        loading: "lazy",
                        alt: "lazypay image",
                        className: "h3"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "f16px lh-copy",
                    children: "Currently we don’t have LazyPay method eligible for you. Please select another payment method"
                }),
                _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_6__/* .deviceWidth */ .o < 799 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "bg-amaranth-color white w-100 mt3 br4 bn fw6 f16px pv16px",
                    onClick: props.onClose,
                    children: "CHOOSE ANOTHER METHOD"
                }) : "Choose another method"
            ]
        });
    };
    var _renderOTPView = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "w-60 fw6 f20px lh-copy mt0",
                    children: [
                        "Enter OTP sent to ‘",
                        paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.phone,
                        "’ & Pay"
                    ]
                }),
                !props.isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "closeicon",
                    onClick: props.onClose,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        loading: "lazy",
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/9sE359Sh.webp",
                        alt: "cancel"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_otp_input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    value: state.OTP,
                    onChange: function(otp) {
                        return handleChange(otp);
                    },
                    numInputs: 4,
                    separator: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: " "
                    }),
                    isInputNum: true,
                    containerStyle: {
                        display: "grid",
                        gridTemplateColumns: "repeat(4,1fr)",
                        gridColumnGap: 0,
                        width: "fit-content",
                        marginTop: 20
                    },
                    shouldAutoFocus: true,
                    inputStyle: {
                        width: 44,
                        height: 44,
                        border: "1px solid #707070",
                        borderRadius: 4,
                        boxShadow: "none",
                        outline: "none",
                        marginRight: 20
                    }
                }),
                state.showIncorrectOtpErr && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "f14px red",
                    children: "Incorrect OTP, entered please enter again."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "timer f14px mb2",
                    style: {
                        marginTop: "20px",
                        display: "block"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                            className: "fw5 mr2 ".concat(state.isTimeUp ? "amaranth-color " : "black-30"),
                            onClick: resendOTP,
                            children: "Resend OTP"
                        }),
                        !state.isTimeUp && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                            className: "fw5 o-30",
                            children: [
                                "in ",
                                "0:".concat(state.timer, " s")
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "bg-amaranth-color white w-100 mt3 br4 bn fw6 f16px pv16px mt4",
                    onClick: onPayBtnHandle,
                    children: "CONFIRM & PAY"
                })
            ]
        });
    };
    var _renderEligibleView = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "mv0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/2qDSXsoj.webp",
                        loading: "lazy",
                        alt: "lazypay image",
                        className: "h3"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "f20px fw6",
                    children: "Confirm your payment with LazyPay"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "f16px fw6",
                    children: [
                        "₹ ",
                        paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.amount
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "bg-amaranth-color white w-100 mt3 br4 bn fw6 f16px pv16px",
                    onClick: props.onClose,
                    children: "CONFIRM & PAY"
                })
            ]
        });
    };
    var _renderView = function(type) {
        switch(type){
            case _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .LAZYPAY_AUTH_MODAL_VIEWS.OTP */ .eS.OTP:
                return _renderOTPView();
            case _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .LAZYPAY_AUTH_MODAL_VIEWS.ELIGIBLE */ .eS.ELIGIBLE:
                return _renderEligibleView();
            case _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .LAZYPAY_AUTH_MODAL_VIEWS.NONELIGIBLE */ .eS.NONELIGIBLE:
                return _renderNotEligibleView();
        }
    };
    return _renderView(lazyPayAuthModal.view);
};
/* harmony default export */ __webpack_exports__["Z"] = (LazyPayAuth);


/***/ }),

/***/ 581887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ usePaymentOptionHandler; }
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(225617);
/* harmony import */ var src_components_Common_Toast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40804);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(804160);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(731024);
/* harmony import */ var src_utils_canDisablePlaceOrder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(596930);
/* harmony import */ var src_utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(913886);
/* harmony import */ var src_utils_isCodDisabledForOrder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(291954);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _useStoreContactDetails__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(299375);
/* harmony import */ var src_utils_getWhatsAppRedirectionUrl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(230066);









function usePaymentOptionHandler() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    var storePhone = (0,_useStoreContactDetails__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().storePhone;
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        return {
            orderDetails: state.orderReducer.orderDetails,
            storeInfo: state.storeReducer.store
        };
    }), orderDetails = ref.orderDetails, storeInfo = ref.storeInfo;
    var onCashOptionHandle = function() {
        var ref;
        if ((0,src_utils_canDisablePlaceOrder__WEBPACK_IMPORTED_MODULE_2__/* .canDisablePlaceOrder */ .w)()) {
            return;
        }
        if ((0,src_utils_isCodDisabledForOrder__WEBPACK_IMPORTED_MODULE_4__/* .isCodDisabledForOrder */ .m)() && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.buyer_pay_value) <= src_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .MINIMUM_ORDER_AMOUNT */ .BI) {
            (0,src_components_Common_Toast__WEBPACK_IMPORTED_MODULE_1__/* .toastNotifyError */ .Lu)("Cannot place order below ".concat(src_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .MINIMUM_ORDER_AMOUNT */ .BI));
            return;
        }
        // Check if the payment is for prepaid order
        if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.payment_method) === src_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .PREPAID_POSTPAID_METHODS.BOTH */ .R9.BOTH && orderDetails.prepaid_flag === src_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .ORDER_PAYMENT_TYPE.PREPAID */ .EY.PREPAID) {
            dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .updateOrderState */ .oW)(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash, (next_router__WEBPACK_IMPORTED_MODULE_5___default())));
        } else {
            dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_9__/* .setPaymentModalVisiblity */ .Tc)(false));
            if (storePhone) {
                // Create whatsapp intent for web and open in next tab
                window.open((0,src_utils_getWhatsAppRedirectionUrl__WEBPACK_IMPORTED_MODULE_7__/* .getWhatAppRedirectionUrlCODRequest */ .eo)(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.buyer_pay_value, orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_id), "_blank");
            }
        }
    };
    return {
        onCashOptionHandle: onCashOptionHandle
    };
}


/***/ }),

/***/ 908623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(225617);

var useUnselectablePaymentOptions = function() {
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        var ref;
        return {
            unselectablePaymentOptionsWithTxnCharge: ((ref = state.paymentReducer.paymentOptionsWithTxnCharge) === null || ref === void 0 ? void 0 : ref.grayed_out_payment_options) || [],
            unselectablePaymentOptions: state.paymentReducer.unselectablePaymentOptions || []
        };
    }), unselectablePaymentOptionsWithTxnCharge = ref.unselectablePaymentOptionsWithTxnCharge, unselectablePaymentOptions = ref.unselectablePaymentOptions;
    var getUnselectablePaymentOptionsToDisplay = function() {
        return (unselectablePaymentOptions === null || unselectablePaymentOptions === void 0 ? void 0 : unselectablePaymentOptions.length) ? unselectablePaymentOptions : (unselectablePaymentOptionsWithTxnCharge === null || unselectablePaymentOptionsWithTxnCharge === void 0 ? void 0 : unselectablePaymentOptionsWithTxnCharge.length) ? unselectablePaymentOptionsWithTxnCharge === null || unselectablePaymentOptionsWithTxnCharge === void 0 ? void 0 : unselectablePaymentOptionsWithTxnCharge.map(function(paymentOption) {
            return paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.payment_option_name;
        }) : [];
    };
    return {
        finalUnselectablePaymentOptions: getUnselectablePaymentOptionsToDisplay()
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useUnselectablePaymentOptions);


/***/ }),

/***/ 596930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ canDisablePlaceOrder; }
/* harmony export */ });
/* harmony import */ var src_redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17247);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(540190);
/* harmony import */ var src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(423653);
/* harmony import */ var src_components_Common_Toast__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40804);
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(506337);





var canDisablePlaceOrder = function() {
    var args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        showMessage: true,
        message: "This is a demo website, you need a live version to proceed this action."
    };
    var ref, ref1, ref2, ref3, // for new stores
    ref4, // for old stores
    ref5;
    var showMessage = args.showMessage, message = args.message;
    var storeInfo = (ref = src_redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.storeReducer) === null || ref1 === void 0 ? void 0 : ref1.store;
    // Disable place order flow for play preview URLs.
    if (_checkRenderEnv__WEBPACK_IMPORTED_MODULE_4__/* .IS_CLIENT */ .kc && ((ref2 = window.location.pathname) === null || ref2 === void 0 ? void 0 : ref2.includes(_routes__WEBPACK_IMPORTED_MODULE_1__.PATH.BUILDER_PREVIEW))) {
        return true;
    }
    // Enable place order flow for stores having theme and staging environment.
    if ( false || !!(storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.premium)) {
        return false;
    }
    var disablePlaceOrder = ((ref3 = window.location.pathname) === null || ref3 === void 0 ? void 0 : ref3.includes(_routes__WEBPACK_IMPORTED_MODULE_1__.PATH.BUILDER_PREVIEW)) || (storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.theme) === null || ref4 === void 0 ? void 0 : ref4.new_subscription_web_status) === src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__/* .NEW_STORE_WEBSITE_STATUS.ACTIVE_NOT_LIVE */ .d6.ACTIVE_NOT_LIVE || (storeInfo === null || storeInfo === void 0 ? void 0 : (ref5 = storeInfo.domain_info) === null || ref5 === void 0 ? void 0 : ref5.domain_type) === 0;
    if (disablePlaceOrder && showMessage && (message === null || message === void 0 ? void 0 : message.trim())) {
        (0,src_components_Common_Toast__WEBPACK_IMPORTED_MODULE_3__/* .toastNotifyError */ .Lu)(message);
    }
    return disablePlaceOrder;
};


/***/ }),

/***/ 291954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ isCodDisabledForOrder; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17247);

function isCodDisabledForOrder() {
    var ref;
    var paymentReducer = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().paymentReducer;
    if (paymentReducer === null || paymentReducer === void 0 ? void 0 : (ref = paymentReducer.otherMethods) === null || ref === void 0 ? void 0 : ref.length) {
        return !(paymentReducer === null || paymentReducer === void 0 ? void 0 : paymentReducer.otherMethods.some(function(method) {
            return method === "cod";
        }));
    } else {
        var ref1, ref2, ref3;
        return (paymentReducer === null || paymentReducer === void 0 ? void 0 : (ref1 = paymentReducer.paymentOptionsWithTxnCharge) === null || ref1 === void 0 ? void 0 : ref1.others) ? !(paymentReducer === null || paymentReducer === void 0 ? void 0 : (ref2 = paymentReducer.paymentOptionsWithTxnCharge) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.others) === null || ref3 === void 0 ? void 0 : ref3.some(function(method) {
            return (method === null || method === void 0 ? void 0 : method.payment_option_name) === "cod";
        })) : true;
    }
}


/***/ })

}]);